import React, { forwardRef } from 'react';
import clsx from 'clsx';
import * as classes from './Headings.module.scss';

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;
type WithVisualLevel = {
    visualLevel?: HeadingLevel,
} & React.HTMLAttributes<HTMLHeadingElement>;
type BaseHeadingProps = {
    level: HeadingLevel,
} & WithVisualLevel;

const BaseHeading = forwardRef<HTMLHeadingElement, BaseHeadingProps>((props, ref) => {
    const { level, visualLevel = level, className, ...rest } = props;
    const Component = `h${level}`;
    const finalClassName = clsx(classes[`h${visualLevel}`], className);
    // @ts-ignore
    return <Component {...rest} className={finalClassName} ref={ref} />;
});

const withLevel = (level: HeadingLevel) => {
    const Component = (props: React.PropsWithRef<WithVisualLevel>) => <BaseHeading level={level} {...props} />;
    Component.displayName = `H${level}`;
    return Component;
};

export const H1 = withLevel(1);
export const H2 = withLevel(2);
export const H3 = withLevel(3);
export const H4 = withLevel(4);
export const H5 = withLevel(5);
export const H6 = withLevel(6);
